<div class="container-fluid utility">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <span class="ma__decorative-link">
          <a href="https://www.mass.gov/orgs/massachusetts-department-of-environmental-protection" class="js-clickable-link" target="_blank" aria-hidden="false" title="Mass.gov Executive Office of Energy and Environmental Affairs (EEA) - Opens in a new window">
            Mass.gov | Executive Office of Energy and Environmental Affairs (EEA)&nbsp;
            <!--</span>-->
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="16" viewBox="0 0 17 16"><defs></defs><path fill="#fff" d="M739.199 92.7986L739.199 80L735.9989999999999 80L735.9989999999999 95.9983L751.9979999999999 95.9983L751.9979999999999 92.7986ZM743.294 81.0032L743.305 83.5605L746.6049999999999 83.5737L742.9939999999999 87.1849L744.809 89.0001L748.4259999999999 85.3836L748.4399999999999 88.6956L750.997 88.7058L750.976 83.59129999999999L750.966 81.03389999999999L748.409 81.02349999999998L748.409 81.02369999999999Z " transform="matrix(1,0,0,1,-735,-80)"></path></svg>

          </a>
          <span class="pull-right">An official application of the Commonwealth of Massachusetts</span>
        </span>

      </div>

    </div>

  </div>
</div>
<!-- <header style="height: 150px;" class="ma__header" id="header">
  <div class="ma__header__container">
  <div class="ma__header__logo">
    <div class="ma__site-logo">
      <a><img alt="Massachusetts State Seal" src="./assets/img/data-portal-logo.png"></a>
    </div>
  </div>

  </div>

</header> -->
<header class="ma__header" id="header">
  <div class="ma__header__container custom__header">
    <div class="ma__header__logo">
      <div class="ma__site-logo">
        <a><img alt="Massachusetts State Seal" src="./assets/img/data-portal-logo.png"></a>
      </div>
    </div>

  </div>
  <nav aria-label="main_navigation" style="padding-left: 40px;" class="ma__header__nav" id="main-navigation" role="navigation">
    <h2 class="visually-hidden" id="main_navigation">
      Main Navigation
    </h2>
    <div class="ma__header__button-container js-sticky-header">
      <button class="ma__header__back-button js-close-sub-nav"><span>Back</span></button>
      <button class="ma__header__menu-button js-header-menu-button" (click)="ShowMobileMenu()"><span>Menu</span><span class="ma__header__menu-icon"></span></button>
    </div>

    <div class="ma__header__nav-container">
      <div class="ma__header__main-nav">
        <section class="ma__main-nav custom__cursor">
          <ul class="ma__main-nav__items js-main-nav" role="menubar">

            <li class="ma__main-nav__item" role="menuitem">
              <button id="homeBtn" aria-current="Home" class="ma__main-nav__top-link" (click)="goToHome()">Home</button>
            </li>
            <li class="ma__main-nav__item" role="menuitem">
              <button id="dashboardBtn" aria-current="Dashboard" class="ma__main-nav__top-link" (click)="goToDataPortal('#!/power-bi-dashboard')">Dashboard</button>
            </li>
            <li role="menuitem" class="ma__main-nav__item has-subnav js-main-nav-toggle" (mouseover)="SearchOnOver()" (mouseout)="SearchOnOut()" tabindex="-1">
              <button id="button2" class="ma__main-nav__top-link" aria-haspopup="true" aria-expanded="false" tabindex="0">
                <span class="visually-hidden show-label">Show the sub topics of </span>Search Data
              </button>
              <div class="ma__main-nav__subitems js-main-nav-content" [ngClass]="searchStyle">
                <ul id="templates" role="menu" aria-labelledby="button2" class="ma__main-nav__container">
                  <li role="menuitem" class="ma__main-nav__subitem">
                    <a href="#" class="ma__main-nav__link">Search Data</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/search/permits')" tabindex="-1">Permits</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/search/facilities')" tabindex="-1">Facilities</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/search/inspections')" tabindex="-1">Inspections</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/search/enforcements')" tabindex="-1">Enforcements</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/search/asbestos')" tabindex="-1">Asbestos</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/search/drinking-water')" tabindex="-1">Drinking Water</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/search/leadandcopper')" tabindex="-1">Lead & Copper in Schools/Childcare</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/search/lsp')" tabindex="-1">Waste Site Cleanup Professionals (LSP Board)</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/search/wire')" tabindex="-1">Wetlands NOI Projects</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/search/welldrilling')" tabindex="-1">Well Drilling</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/search/npdes')" tabindex="-1">Wastewater NPDES & Residuals PFAS</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('/dep/cso-data-portal/')" tabindex="-1">Sewage Notification</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('/dep/wastesite/')" tabindex="-1">Waste Site Cleanup</a>
                  </li>
                  <li role="presentation"></li>
                </ul>
              </div>
            </li>
            <li role="menuitem" class="ma__main-nav__item has-subnav js-main-nav-toggle" (mouseover)="HelpOnOver()" (mouseout)="HelpOnOut()" tabindex="-1">
              <button id="button2" class="ma__main-nav__top-link" aria-haspopup="true" aria-expanded="false" tabindex="0">
                <span class="visually-hidden show-label">Show the sub topics of </span>Help
              </button>
              <div class="ma__main-nav__subitems js-main-nav-content" [ngClass]="helpStyle">
                <ul id="templates" role="menu" aria-labelledby="button2" class="ma__main-nav__container">
                  <li role="menuitem" class="ma__main-nav__subitem">
                    <a href="#" class="ma__main-nav__link">Help</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/faqs')" tabindex="-1">FAQs</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/terms-conditions')" tabindex="-1">Terms & Conditions</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/policies')" tabindex="-1">EEA Site Policies</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/suggestions-and-comments')" tabindex="-1">Suggestions</a>
                  </li>
                  <li role="presentation" class="ma__main-nav__subitem">
                    <a class="ma__main-nav__link" (click)="goToDataPortal('#!/disclaimer')" tabindex="-1">Disclaimer</a>
                  </li>
                  <li role="presentation"></li>
                </ul>
              </div>
            </li>
          </ul>
        </section>
      </div>
    </div>
  </nav>
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
  </ngx-spinner>
</header>


